__turbopack_context__.v({
  "appCaption": "newThingsCo-module__qG5-cG__appCaption",
  "appImage": "newThingsCo-module__qG5-cG__appImage",
  "appItem": "newThingsCo-module__qG5-cG__appItem",
  "applicationsGrid": "newThingsCo-module__qG5-cG__applicationsGrid",
  "applicationsHeader": "newThingsCo-module__qG5-cG__applicationsHeader",
  "applicationsSection": "newThingsCo-module__qG5-cG__applicationsSection",
  "brandSection": "newThingsCo-module__qG5-cG__brandSection",
  "galleryContent": "newThingsCo-module__qG5-cG__galleryContent",
  "galleryHeader": "newThingsCo-module__qG5-cG__galleryHeader",
  "gallerySection": "newThingsCo-module__qG5-cG__gallerySection",
  "imageGrid": "newThingsCo-module__qG5-cG__imageGrid",
  "metaBlock": "newThingsCo-module__qG5-cG__metaBlock",
  "metaGrid": "newThingsCo-module__qG5-cG__metaGrid",
  "metaLabel": "newThingsCo-module__qG5-cG__metaLabel",
  "metaLeft": "newThingsCo-module__qG5-cG__metaLeft",
  "metaOverview": "newThingsCo-module__qG5-cG__metaOverview",
  "metaRight": "newThingsCo-module__qG5-cG__metaRight",
  "metaSection": "newThingsCo-module__qG5-cG__metaSection",
  "metaText": "newThingsCo-module__qG5-cG__metaText",
  "metaTools": "newThingsCo-module__qG5-cG__metaTools",
  "outcomesSection": "newThingsCo-module__qG5-cG__outcomesSection",
  "page": "newThingsCo-module__qG5-cG__page",
  "printSection": "newThingsCo-module__qG5-cG__printSection",
  "processSection": "newThingsCo-module__qG5-cG__processSection",
  "resultDetail": "newThingsCo-module__qG5-cG__resultDetail",
  "resultItem": "newThingsCo-module__qG5-cG__resultItem",
  "resultLabel": "newThingsCo-module__qG5-cG__resultLabel",
  "resultValue": "newThingsCo-module__qG5-cG__resultValue",
  "resultsContent": "newThingsCo-module__qG5-cG__resultsContent",
  "resultsGrid": "newThingsCo-module__qG5-cG__resultsGrid",
  "resultsSection": "newThingsCo-module__qG5-cG__resultsSection",
  "storySection": "newThingsCo-module__qG5-cG__storySection",
  "videoCaption": "newThingsCo-module__qG5-cG__videoCaption",
  "videoContainer": "newThingsCo-module__qG5-cG__videoContainer",
  "videoSection": "newThingsCo-module__qG5-cG__videoSection",
});
